import {
  ICategoryGlobalListingResponse,
  ICategoryGlobalListingNormalizedData,
  ICategoryGlobalPayload,
} from "../interfaces/Index";

interface ICoreCatgoryGlobal {
  key: string;
  value: string;
}

export const normalizeCategoryGlobalListing = (
  res: Array<Array<ICategoryGlobalListingResponse>>,
  pagination: number | boolean,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };

  res = res.map((items: any) => {
    let catParentId: any;
    return items.map((item: any) => {
      if (item.categoryType === "parent") {
        catParentId = item.id;
      }

      return {
        id: item.id,
        categoryTitle: item.title,
        categoryType: item.categoryType === "parent" ? "core" : "sub_category",
        parentId: item.categoryType === "child" ? catParentId : null,
        categoryHandle: item.handle || "",
        cities: item.cities,
      };
    });
  });

  payload.categoriesGlobalData = res;

  return payload;
};


export const normalizeProductDetailPageCategoryGlobalListing = (
  res: Array<Array<ICategoryGlobalListingResponse>>,
  pagination: number | boolean,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };
  let categoriesGlobalData: Array<ICategoryGlobalListingNormalizedData> = [];

  res.forEach((categoryGlobal: Array<ICategoryGlobalListingResponse>) => {
    let catParentId: any;
    if (categoryGlobal.length > 1) {
      categoryGlobal.forEach((items: ICategoryGlobalListingResponse) => {
        if (items.categoryType === "parent") catParentId = items.id;
        const listItem: any = {
          id: items.id,
          categoryGlobalTitle: items.title,
          categoryType:
            items.categoryType === "parent" ? "core" : "sub_category",
          parentId: items.categoryType === "child" ? catParentId : null,
          categoryGlobalHandle: items.handle || "",
          cities: items.cities
        };
        categoriesGlobalData.push(listItem);
      });
    } else {
      categoryGlobal.forEach((items: ICategoryGlobalListingResponse) => {
        const listItem: any = {
          id: items.id,
          categoryGlobalTitle: items.title,
          categoryType:
            items.categoryType === "parent" ? "core" : "sub_category",
          parentId: null,
          categoryGlobalHandle: items.handle || "",
          cities: items.cities
        };
        categoriesGlobalData.push(listItem);
      });
    }
  });

  payload.categoriesGlobalData = categoriesGlobalData;
  return payload;
};

export const normalizeCoreCategoryGlobal = (payload: Array<ICoreCatgoryGlobal> = []) => {
  return payload.map((coreCategory) => {
    return {
      id: coreCategory.key,
      value: coreCategory.value,
      title: coreCategory.value,
      key: coreCategory.key,
    };
  });
};

export const normalizeCategoryGlobalReqPayload = (
  payload: ICategoryGlobalPayload,
  isEdit: boolean = false
) => {
  let reqPayload: any = {};
  if (payload.categoryType === "sub_category") {
    reqPayload.parentCategoryId = payload.coreCategory;
  }
  reqPayload.name = payload.categoryTitle;
  reqPayload.handle = payload.categoryHandle || "";
  reqPayload.cities = payload.cities.map((cityId) => {
    return cityId.id;
  });
  if (isEdit) {
    reqPayload.id = payload.id;
  }

  return reqPayload;
};

export const normalizeSelectedPayloadForEditFlow = (
  categoryGlobal: ICategoryGlobalListingNormalizedData
) => {
  return {
    ...categoryGlobal,
    coreCategory: categoryGlobal.parentId,
  };
};